"use strict";

exports.__esModule = true;
var safelyParseJson = function safelyParseJson(parseString) {
  try {
    return JSON.parse(parseString);
  } catch (e) {
    // @ts-ignore
    return null;
  }
};
exports["default"] = safelyParseJson;